var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-content-center container-geral-financeiro"},[_c('div',{staticClass:"container-components-financeiro",attrs:{"role":"tablist"}},[_c('Bill',{attrs:{"isProvider":_vm.isProvider,"title":_vm.title,"type":_vm.type,"label":_vm.label}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }